import { render, staticRenderFns } from "./BetsBox.vue?vue&type=template&id=b3f600c0&scoped=true"
import script from "./BetsBox.vue?vue&type=script&lang=js"
export * from "./BetsBox.vue?vue&type=script&lang=js"
import style0 from "./BetsBox.vue?vue&type=style&index=0&id=b3f600c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f600c0",
  null
  
)

export default component.exports